<div class="margin">
    <panel heading="{{'Additional Observations' | translate | async}}">

      <div class="table-container" [@slideOut] >
        <table class="table table--full-width table--striped">
          <thead>
            <tr>
              <!-- <th></th> -->
              <th>{{'Description' | translate | async}}</th>
              <th></th>
              <th>{{'Answer' | translate | async}}</th>
              <th>{{'Image' | translate | async}}</th>
              <th>{{'Comment' | translate | async}}</th>
              <th>{{'Delete' | translate | async}}</th>
              <td><button mat-raised-button color="warn"  (click)="AddNewObservationList()"> <i  class="material-icons">add</i> {{"Add Observations"|translate|async}}</button> </td>
            </tr>
          </thead>
          <tbody *ngIf="observationLists?.length > 0"  [@slideOut] >
            <tr *ngFor="let ob of observationLists">

              <td> {{ob.Title}} </td>
              <td>
                <i   class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;cursor: pointer;"  title="Edit Additional Observation" (click)="EditObservation(ob)" >
                  create
                </i>
              </td>

              <td>
                <div *ngIf="ob.QuestionTypeId==0" class="upload-container" >
                  
                </div>
                <div *ngIf="ob.HasAnswerd==false && ob.QuestionTypeId>0" class="upload-container" (click)="AnswerAdditonalObs(ob)" title="Add Answer">
                  <i class="material-icons upload-container__icon">
                    comment
                  </i>
                </div>

                <div style="display: flex;">
                  <div *ngIf="ob.HasAnswerd==true && ob.QuestionTypeId>0" class="upload-container" (click)="AnswerAdditonalObs(ob)" title="Edit Answer">
                    <i class="material-icons upload-container__icon"  style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;cursor: pointer;" >
                      comment
                    </i>
                  </div>
                 
                  <div style="display: flex; flex-direction: row;height: fit-content;
                  align-self: center;" *ngIf="ob.QuestionTypeId==5 && ob.wornPercent!=null && ob.HasAnswerd==true">
                    <span class="Eval-{{ ob.wornPercent | wornPercentageToEval}}"
                        style="margin-right: 0px;">
                        <div>{{ob.wornPercent}}%</div>
                    </span>
                </div>
                </div>
              </td>
              <td class="inspection-component-photo">
                <upload-photo   [comingFrom]="PopupEndPoint"  (onPhotoUpload)="reloadObservationPhoto(ob)" [ObservationListId]="ob.Id" ></upload-photo>
                <img *ngFor="let photo of ob.ObsImages"  (click)="viewObservationListPhoto(ob,photo)" class="inspection-observation-photo" [src]="getImage(photo.Image)"  />
              </td>

             <td class="inspection-component-photo">
               <add-component-comment [endPoint]="PopupEndPoint" (onCommentChange)="reloadObservatioComment(ob)" [comment]="ob.Comment" [observationList]="ob" ></add-component-comment></td>
              <td>
                <i   class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;cursor: pointer;"  title="Delete Additional Observation" (click)="OpenDeleteAdditionalObs(ob.Id)" >
                  delete
                </i>
              </td>
            </tr>
          </tbody>

          <div *ngIf="observationLists?.length == 0">{{ "Currently there is no observation list configured for this inspection and this equipment" | translate | async}}</div>
        </table>
      </div>
    </panel>
  </div>
